"use strict";

require("./index.css");


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/antd/lib/locale-provider/style/css.js
// module id = 568
// module chunks = 20